module.exports = __webpack_public_path__ + "img/моя мастерская 80х95.411e2a07.jpg";